import { getUserHistory } from "../../Reducers/userHistory/getUserHistory"
import { useReducer } from "react"
import { globalInitialState } from "../initialStateGlobal"

export const useUserHistoryState = () =>{
  const [state, dispatch] = useReducer(getUserHistory, globalInitialState);
  return {state, dispatch};
}
